/**
 * 計算フィールド（#3145 / #3172）結果画面の表示文言。
 * 計算エンジン自体のエラーメッセージは utils/calculation/constants.ts（functions と共通）にあり、
 * ここには結果画面固有の文言だけを置く。
 */
export const calculationResultMessage = {
  /** AI読取ONの計算フィールドで、計算できず読み取り値へフォールバックしたときの案内（設計書 §4.8） */
  fallbackToOcr: '計算できなかったため読み取り値を表示しています',
} as const;
